import y1950 from '../assets/1950.svg';
import y1973 from '../assets/1973.svg';
import y1983 from '../assets/1983.svg';
import y1985 from '../assets/1985.svg';
import y1992 from '../assets/1992.svg';
import y1995 from '../assets/1995.svg';
import y1996 from '../assets/1996.svg';
import y1999 from '../assets/1999.svg';
import y2001 from '../assets/2001.svg';
import y2004 from '../assets/2004.svg';
import y2005 from '../assets/2005.svg';
import y2006 from '../assets/2006.svg';
import y2007 from '../assets/2007.svg';
import y2008 from '../assets/2008.svg';
import y2009 from '../assets/2009.svg';
import y2010 from '../assets/2010.svg';
import y2011 from '../assets/2011.svg';
import y2012 from '../assets/2012.svg';
import y2013 from '../assets/2013.svg';
import y2014 from '../assets/2014.svg';
import y2015 from '../assets/2015.svg';
import y2016 from '../assets/2016.svg';
import y2017 from '../assets/2017.svg';
import y2018 from '../assets/2018.svg';
import y2019 from '../assets/2019.svg';

const backgrounds = {
	1950: {
		year: 1950,
		background: y1950,
		width: '185vw',
		left: '-75vw',
		top: '-124vh',
	},
	1973: {
		year: 1973,
		background: y1973,
		width: '180vw',
		left: '-72vw',
		top: '-120vh',
	},
	1983: {
		year: 1983,
		background: y1983,
		width: '175vw',
		left: '-69vw',
		top: '-118vh',
	},
	1985: {
		year: 1985,
		background: y1985,
		width: '170vw',
		left: '-65vw',
		top: '-113vh',
	},
	1992: {
		year: 1992,
		background: y1992,
		width: '168vw',
		left: '-64vw',
		top: '-112vh',
	},
	1995: {
		year: 1995,
		background: y1995,
		width: '165vw',
		left: '-62vw',
		top: '-112vh',
	},
	1996: {
		year: 1996,
		background: y1996,
		width: '163vw',
		left: '-60vw',
		top: '-112vh',
	},
	1999: {
		year: 1999,
		background: y1999,
		width: '156vw',
		left: '-56vw',
		top: '-105vh',
	},
	2001: {
		year: 2001,
		background: y2001,
		width: '152vw',
		left: '-54vw',
		top: '-98vh',
	},
	2004: {
		year: 2004,
		background: y2004,
		width: '152vw',
		left: '-56vw',
		top: '-98vh',
	},
	2005: {
		year: 2005,
		background: y2005,
		width: '150vw',
		left: '-56vw',
		top: '-92vh',
	},
	2006: {
		year: 2006,
		background: y2006,
		width: '150vw',
		left: '-57vw',
		top: '-100vh',
	},
	2007: {
		year: 2007,
		background: y2007,
		width: '147vw',
		left: '-55vw',
		top: '-100vh',
	},
	2008: {
		year: 2008,
		background: y2008,
		width: '140vw',
		left: '-50vw',
		top: '-92vh',
	},
	2009: {
		year: 2009,
		background: y2009,
		width: '137vw',
		left: '-49vw',
		top: '-84vh',
	},
	2010: {
		year: 2010,
		background: y2010,
		width: '128vw',
		left: '-42vw',
		top: '-80vh',
	},
	2011: {
		year: 2011,
		background: y2011,
		width: '117vw',
		left: '-34vw',
		top: '-70vh',
	},
	2012: {
		year: 2012,
		background: y2012,
		width: '114vw',
		left: '-33vw',
		top: '-68vh',
	},
	2013: {
		year: 2013,
		background: y2013,
		width: '110vw',
		left: '-30vw',
		top: '-60vh',
	},
	2014: {
		year: 2014,
		background: y2014,
		width: '19vw',
		left: '-30vw',
		top: '-60vh',
	},
	2015: {
		year: 2015,
		background: y2015,
		width: '114vw',
		left: '-34vw',
		top: '-64vh',
	},
	2016: {
		year: 2016,
		background: y2016,
		width: '110vw',
		left: '-31vw',
		top: '-60vh',
	},
	2017: {
		year: 2017,
		background: y2017,
		width: '114vw',
		left: '-38vw',
		top: '-72vh',
	},
	2018: {
		year: 2018,
		background: y2018,
		width: '112vw',
		left: '-37vw',
		top: '-72vh',
	},
	2019: {
		year: 2019,
		background: y2019,
		width: '113vw',
		left: '-38vw',
		top: '-66vh',
	},
};

export default backgrounds;
